var CustomerFieldKeys = /* @__PURE__ */ ((CustomerFieldKeys2) => {
  CustomerFieldKeys2["email"] = "email";
  CustomerFieldKeys2["country"] = "country";
  CustomerFieldKeys2["nickname"] = "nickname";
  CustomerFieldKeys2["firstName"] = "firstName";
  CustomerFieldKeys2["middleName"] = "middleName";
  CustomerFieldKeys2["lastName"] = "lastName";
  CustomerFieldKeys2["password"] = "password";
  CustomerFieldKeys2["currency"] = "currency";
  CustomerFieldKeys2["promoCode"] = "promoCode";
  CustomerFieldKeys2["taxId"] = "taxId";
  CustomerFieldKeys2["gender"] = "gender";
  CustomerFieldKeys2["city"] = "city";
  CustomerFieldKeys2["street"] = "street";
  CustomerFieldKeys2["postCode"] = "postCode";
  CustomerFieldKeys2["prefix"] = "prefix";
  CustomerFieldKeys2["phone"] = "phone";
  CustomerFieldKeys2["smsCode"] = "smsCode";
  CustomerFieldKeys2["provinceId"] = "provinceId";
  CustomerFieldKeys2["day"] = "day";
  CustomerFieldKeys2["month"] = "month";
  CustomerFieldKeys2["year"] = "year";
  CustomerFieldKeys2["personalCode"] = "personalCode";
  CustomerFieldKeys2["promotion"] = "promotion";
  CustomerFieldKeys2["acceptPolicy"] = "acceptPolicy";
  CustomerFieldKeys2["registrationDocNumber"] = "registrationDocNumber";
  CustomerFieldKeys2["registrationDocTypeId"] = "registrationDocTypeId";
  CustomerFieldKeys2["bonusType"] = "bonusType";
  CustomerFieldKeys2["birthday"] = "birthday";
  CustomerFieldKeys2["occupationId"] = "occupationId";
  CustomerFieldKeys2["nationality"] = "nationality";
  CustomerFieldKeys2["iban"] = "iban";
  CustomerFieldKeys2["socialMethod"] = "socialMethod";
  return CustomerFieldKeys2;
})(CustomerFieldKeys || {});
var TextInfoFields = /* @__PURE__ */ ((TextInfoFields2) => {
  TextInfoFields2["recaptchaProtectedText"] = "recaptcha";
  TextInfoFields2["acceptPolicyText"] = "acceptPolicyText";
  return TextInfoFields2;
})(TextInfoFields || {});
var ConfigurableButtons = /* @__PURE__ */ ((ConfigurableButtons2) => {
  ConfigurableButtons2["submitButton"] = "submitButton";
  return ConfigurableButtons2;
})(ConfigurableButtons || {});
var RegistrationButtonActions = /* @__PURE__ */ ((RegistrationButtonActions2) => {
  RegistrationButtonActions2["getSocialMediaLink"] = "getSocialMediaLink";
  RegistrationButtonActions2["changeStep"] = "changeStep";
  RegistrationButtonActions2["checkTaxId"] = "checkTaxId";
  return RegistrationButtonActions2;
})(RegistrationButtonActions || {});
var InputValidationOptions = /* @__PURE__ */ ((InputValidationOptions2) => {
  InputValidationOptions2["serverValidation"] = "serverValidation";
  InputValidationOptions2["regexp"] = "regex";
  InputValidationOptions2["minLength"] = "minLength";
  InputValidationOptions2["singleLowercase"] = "singleLowercase";
  InputValidationOptions2["singleUppercase"] = "singleUppercase";
  InputValidationOptions2["singleNumber"] = "singleNumber";
  InputValidationOptions2["password"] = "password";
  return InputValidationOptions2;
})(InputValidationOptions || {});
export {
  ConfigurableButtons,
  CustomerFieldKeys,
  InputValidationOptions,
  RegistrationButtonActions,
  TextInfoFields
};
